import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import classNames from 'classnames';
import moment from 'moment';
import React, { useState } from 'react';
import { useDeviceInfo } from '../../hooks/useDeviceInfo';
import { ICodeRedemptionCodeType } from '../../interfaces';
import { Icon } from '../../subkit-ui';
import { getPriceString } from '../../utils/helpers';
import { Modal } from '../Modal';
import { Separator } from '../Separator';
import TWSubscriptionPlan, { TWSubscriptionPlanCardType } from '../TWSubscriptionPlan';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var renderInvoiceLines = function renderInvoiceLines(lines, invoicePreview, planItems) {
  return lines.map(function (line, index) {
    var _line$options, _line$options2;

    var priceString = getPriceString(line.amount, invoicePreview.currency);
    return /*#__PURE__*/_jsxs("div", {
      className: classNames("flex fw-500", {
        'h-6': !(index === 0),
        'mb-0': index === lines.length - 1,
        'mb-6': index === 0,
        'mb-4': index !== lines.length - 1
      }),
      "data-cy": "invoice-line-".concat(line.id),
      children: [/*#__PURE__*/_jsx("div", {
        className: classNames('self-center flex-1', {
          'line-clamp-1': !(planItems !== null && planItems !== void 0 && planItems.showPlan)
        }),
        children: (_line$options = line.options) !== null && _line$options !== void 0 && _line$options.large ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("h3", {
            className: "m-0 text-lg font-semibold",
            children: line.name
          }), (planItems === null || planItems === void 0 ? void 0 : planItems.showPlan) && index === 0 && /*#__PURE__*/_jsx("span", {
            className: " block text-subkit-primary text-base cursor-pointer",
            onClick: function onClick() {
              return planItems.setPlanModal(true);
            },
            children: "View Plan"
          })]
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [!line.type && line.name, line.type === 'balance' && /*#__PURE__*/_jsxs("div", {
            className: "text-gray-500",
            children: [/*#__PURE__*/_jsx(Icon, {
              name: "wallet",
              className: "pr-2"
            }), line.name]
          }), line.type === ICodeRedemptionCodeType.SHARE && /*#__PURE__*/_jsxs("div", {
            className: "text-yellow-500",
            children: [/*#__PURE__*/_jsx(Icon, {
              name: "megaphone",
              className: "pr-2"
            }), line.name]
          }), line.type === ICodeRedemptionCodeType.COUPON && /*#__PURE__*/_jsxs("div", {
            className: "text-green-700",
            children: [/*#__PURE__*/_jsx(Icon, {
              name: "tag",
              className: "pr-2"
            }), line.name]
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: classNames("line-clamp-1 min-w-max", {
          'text-green-700': line.type === ICodeRedemptionCodeType.COUPON,
          'text-yellow-500': line.type === ICodeRedemptionCodeType.SHARE,
          'text-gray-500': line.type === 'balance'
        }),
        children: (_line$options2 = line.options) !== null && _line$options2 !== void 0 && _line$options2.large ? /*#__PURE__*/_jsx("h3", {
          className: "m-0",
          children: priceString
        }) : priceString
      })]
    }, line.id);
  });
};

var TWInvoicePreview = function TWInvoicePreview(_ref) {
  var _invoicePreview$lines, _invoicePreview$prepa, _invoicePreview$prepa2, _invoicePreview$prepa3, _invoicePreview$prepa4, _invoicePreview$prepa5;

  var invoicePreview = _ref.invoicePreview,
      totalLineItemTitle = _ref.totalLineItemTitle;

  var _useState = useState(false),
      showModal = _useState[0],
      _setModal = _useState[1];

  var deviceInfo = useDeviceInfo();
  if (!(invoicePreview !== null && invoicePreview !== void 0 && (_invoicePreview$lines = invoicePreview.lines) !== null && _invoicePreview$lines !== void 0 && _invoicePreview$lines.length)) return null;

  var plan = _objectSpread(_objectSpread({}, invoicePreview === null || invoicePreview === void 0 ? void 0 : (_invoicePreview$prepa = invoicePreview.preparedFor) === null || _invoicePreview$prepa === void 0 ? void 0 : _invoicePreview$prepa.plan), {}, {
    invoicePreview: invoicePreview
  });

  var lines = invoicePreview.lines;

  var _lines$filter = lines.filter(function (l) {
    return l.type === 'no_charge' || !l.type;
  }),
      _lines$filter2 = _slicedToArray(_lines$filter, 1),
      firstNormalLine = _lines$filter2[0];

  if (firstNormalLine) firstNormalLine.options = {
    large: true
  };
  var isTrial = ((_invoicePreview$prepa2 = invoicePreview.preparedFor.subscription) === null || _invoicePreview$prepa2 === void 0 ? void 0 : _invoicePreview$prepa2.status) === 'trialing' || ((_invoicePreview$prepa3 = invoicePreview.preparedFor.plan) === null || _invoicePreview$prepa3 === void 0 ? void 0 : _invoicePreview$prepa3.trial_period_days) > 0;
  var renewalDateString = "";

  if (invoicePreview.currentPeriodEnd) {
    var renewalDate = new Date(invoicePreview.currentPeriodEnd * 1000);
    renewalDateString = moment(renewalDate).format('MMMM D, yyyy');
  } else if ((_invoicePreview$prepa4 = invoicePreview.preparedFor) !== null && _invoicePreview$prepa4 !== void 0 && (_invoicePreview$prepa5 = _invoicePreview$prepa4.plan) !== null && _invoicePreview$prepa5 !== void 0 && _invoicePreview$prepa5.interval) {
    var _invoicePreview$prepa6;

    var _renewalDate;

    if (((_invoicePreview$prepa6 = invoicePreview.preparedFor.plan) === null || _invoicePreview$prepa6 === void 0 ? void 0 : _invoicePreview$prepa6.trial_period_days) > 0) {
      var _invoicePreview$prepa7;

      _renewalDate = moment().add((_invoicePreview$prepa7 = invoicePreview.preparedFor.plan) === null || _invoicePreview$prepa7 === void 0 ? void 0 : _invoicePreview$prepa7.trial_period_days, 'days').toDate();
    } else {
      _renewalDate = moment().add(invoicePreview.preparedFor.plan.interval_count, invoicePreview.preparedFor.plan.interval).toDate();
    }

    renewalDateString = moment(_renewalDate).format('MMMM D, yyyy');
  }

  var planItems = plan.id ? {
    showPlan: true,
    setPlanModal: _setModal
  } : null;
  var nextBillingText = 'Renews automatically';

  if (invoicePreview.scheduledDowngrade) {
    var priceString = getPriceString(firstNormalLine.amount, invoicePreview.currency);
    nextBillingText = "".concat(priceString, " will be charged");
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!!plan && /*#__PURE__*/_jsx(Modal, {
      classes: "w-full lg:w-11/12 xl:w-3/5 h-3/4 md:h-auto overflow-auto overscroll-contain",
      showModal: showModal,
      setModal: function setModal(_ref2) {
        var show = _ref2.show;
        return _setModal(show);
      },
      children: /*#__PURE__*/_jsx(TWSubscriptionPlan, {
        plan: plan,
        disableButton: true,
        type: deviceInfo.mobile || deviceInfo.tablet ? TWSubscriptionPlanCardType.SKINNY : TWSubscriptionPlanCardType.FULL_WIDTH,
        noShadow: true
      })
    }), renderInvoiceLines(lines, invoicePreview, planItems), /*#__PURE__*/_jsx(Separator, {
      classNames: "my-6"
    }), renderInvoiceLines([{
      name: totalLineItemTitle,
      amount: invoicePreview.total,
      id: 'total',
      description: '',
      quantity: 1
    }], invoicePreview), /*#__PURE__*/_jsx(Separator, {
      classNames: "my-6"
    }), invoicePreview.paymentSource && /*#__PURE__*/_jsxs("div", {
      className: "my-4",
      children: [/*#__PURE__*/_jsx(Icon, {
        type: "regular",
        name: "credit-card",
        className: "pr-2"
      }), invoicePreview.paymentSource.brand, " ending in ", /*#__PURE__*/_jsx("strong", {
        children: invoicePreview.paymentSource.last4
      }), renewalDateString && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' on ', /*#__PURE__*/_jsx("strong", {
          children: renewalDateString
        })]
      })]
    }), !invoicePreview.paymentSource && renewalDateString && /*#__PURE__*/_jsxs("div", {
      className: "my-4 fw-500",
      children: [nextBillingText, " on ", renewalDateString]
    }), /*#__PURE__*/_jsxs("div", {
      className: classNames('my-4 text-gray-500'),
      children: [isTrial && !invoicePreview.switchingPlan && /*#__PURE__*/_jsx(_Fragment, {
        children: "If you cancel before your free trial ends, you will not be charged. You can change or cancel your subscription at anytime."
      }), (!isTrial || invoicePreview.switchingPlan) && /*#__PURE__*/_jsx(_Fragment, {
        children: "You can change or cancel your subscription at any time."
      })]
    })]
  });
};

export default TWInvoicePreview;